import { useState, useEffect } from "react";

export function useCountdown(totalSeconds: number): number {
  const [remaining, setRemaining] = useState(totalSeconds);

  useEffect(() => {
    setRemaining(totalSeconds);
    if (totalSeconds <= 0) return;

    const id = setInterval(() => {
      setRemaining((prev) => {
        const next = prev - 1;
        if (next <= 0) {
          clearInterval(id);
          return 0;
        }
        return next;
      });
    }, 1000);

    return () => clearInterval(id);
  }, [totalSeconds]);

  return remaining;
}
